import Vue from "vue";
import Router from "vue-router";
import decode from "jwt-decode";
// import Home from "./views/Home.vue";
import store from "./store/store";

Vue.use(Router);

function AccessRout() {
  return decode(store.getters.showRtoken);
}

function authentication(to, from, next) {
  try {
    store.dispatch("AutoLogin");

    if (store.getters.showToken) {
      let ogol = AccessRout().ogol;
      // console.log(ogol);
      if (!ogol.length) {
        next();
      } else {
        let isAccess = false;
        for (let index = 0; index < ogol.length; index++) {
          if (ogol[index] == to.meta.name) isAccess = true;
        }
        if (isAccess) next();
        else next("/noAccess");
      }
    } else next("/login");
  } catch (error) {
    // console.log("Eorro-- ", error);
  }
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () => import("./views/logIn.vue"),
      name: "login",
      beforeEnter(to, from, next) {
        store.dispatch("AutoLogin");
        if (!store.getters.isAuthenticated) next();
        else next("/");
      },
    },
    {
      path: "/404",
      name: "404",
      component: () => import("./views/NotFound.vue"),
    },
    {
      path: "*",
      redirect: { name: "404" },
    },
    {
      path: "/",
      name: "home",
      meta: { name: "Home" },
      beforeEnter: authentication,
      // component: Home,
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/noAccess",
      name: "NoAccessPage",
      meta: { name: "No Access" },
      beforeEnter: (to, from, next) => {
        if (store.getters.showToken) next();
        else next("/login");
      },
      // component: Home,
      component: () => import("./views/NoAccess.vue"),
    },
    {
      path: "/income",
      name: "income",
      meta: { name: "Inocme" },
      beforeEnter: authentication,
      component: () => import("./views/Exchange/income.vue"),
    },
    {
      path: "/newCustomer",
      name: "newCustomer",
      meta: { name: "New client" },
      beforeEnter: authentication,
      component: () => import("./views/NewCustomer.vue"),
    },
    {
      path: "/exchangeReport",
      name: "exchangeRep",
      meta: { name: "Genral Report" },
      beforeEnter: authentication,
      component: () => import("./views/exchangeReport.vue"),
    },
    {
      path: "/usdReport",
      name: "usdReport",
      meta: { name: "USD Report" },
      beforeEnter: authentication,
      component: () => import("./views/USDReport.vue"),
    },
    {
      path: "/ExpenseEntry",
      name: "ExpenseEntry",
      meta: { name: "New Expense" },
      beforeEnter: authentication,
      component: () => import("./views/ExpenseEntry.vue"),
    },
    {
      path: "/transfer",
      name: "CashTransfer",
      meta: { name: "Cash Transfer" },
      beforeEnter: authentication,
      component: () => import("./views/CashTransfer.vue"),
    },
    {
      path: "/AllCash",
      name: "AllCashList",
      meta: { name: "All Cash Balance" },
      beforeEnter: authentication,
      component: () => import("./views/AllCash.vue"),
    },
    {
      path: "/groups",
      name: "groups",
      meta: { name: "Groups" },
      beforeEnter: authentication,
      component: () => import("./views/Groups.vue"),
    },
    {
      path: "/AddUser",
      name: "AddUser",
      meta: { name: "User List" },
      beforeEnter: authentication,
      component: () => import("./views/AddUsser.vue"),
    },

    {
      path: "/cashDep",
      name: "cashDeposit",
      meta: { name: "Money Dep" },
      beforeEnter: authentication,
      component: () => import("./views/MoneyDeposite.vue"),
    },
    {
      path: "/deletetran",
      name: "Delete",
      meta: { name: "Delete" },
      beforeEnter: authentication,
      component: () => import("./views/deletetran.vue"),
    },
    {
      path: "/BankReports",
      name: "BankReport",
      meta: { name: "Bank Summary" },
      beforeEnter: authentication,
      component: () => import("./views/BankReport.vue"),
    },
    {
      path: "/AllSummary",
      name: "AllSummaryReport",
      meta: { name: "All Summary" },
      beforeEnter: authentication,
      component: () => import("./views/AllSumery.vue"),
    },
    {
      path: "/Transactions",
      name: "Transactions",
      meta: { name: "Transactions" },
      beforeEnter: authentication,
      component: () => import("./views/MoneyTransaction.vue"),
    },
    {
      path: "/expenses",
      name: "expenses",
      meta: { name: "Show Expenses" },
      beforeEnter: authentication,
      component: () => import("./views/allExpense.vue"),
    },
    {
      path: "/debts",
      name: "debts",
      meta: { name: "Debts" },
      beforeEnter: authentication,
      component: () => import("./views/debts.vue"),
    },
    {
      path: "/clientCashes",
      name: "ClientCashes",
      meta: { name: "Account Report" },
      beforeEnter: authentication,
      component: () => import("./views/clientCashes.vue"),
    },
    {
      path: "/Customers",
      name: "Customers",
      meta: { name: "All Clients" },
      beforeEnter: authentication,
      component: () => import("./views/customers.vue"),
    },
    // {
    //   path: "/NewAccount",
    //   name: "NewAccount",
    //   meta: { name: "Not Allowed Route" },
    //   component: () => import("./views/CreateAccount.vue"),
    // },
    // {
    //   path: "/Customer/:CustomerID",
    //   name: "customer",
    //   meta: { name: "All Clients" },
    //   props: true,
    //   beforeEnter: authentication,
    //   component: () => import("./components/Clients/CustomInfo.vue"),
    // },
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // }
  ],
});
